module.exports = __webpack_public_path__ + "img/Share.8a1318f8.svg";